import React from 'react'
import { Link } from 'react-router-dom'

const cpem46 = () => {
  return (
    <div className='seccion_menu'>
        <div className='seccion'>
            <h2> C.P.E.M. N° 46 </h2>
            <h4>Planilla datos personales</h4>

            <Link to='/IndexPersonales' className='btn'>ACCESO</Link>
      
            <Link to='/AgregarDocentes' className='btn'>Agregar</Link>

        </div>        
    </div>
  )
}

export default cpem46